import React from 'react';
import { CtaButton } from './CtaButton';
import { ProductStack } from './ProductStack';
const chips = ['6 Volumes', '60 Ready-to-Teach Sessions', '5 Bonuses', '300 Pages', '3 Lanes per Skill'];
const micro = ['Instant PDF download', '7-day money-back guarantee', 'Works with any school or lineage'];

// Colores de los carriles y roles (leyenda del producto)
const lanes = ['bg-ground', 'bg-lift', 'bg-fly', 'bg-coral', 'bg-saffron'];
export function Hero() {
  return <section className="relative w-full overflow-hidden bg-sand" data-id="element-153" data-mp="x9uqdm4c7y8b">
      <div className="relative z-10 mx-auto max-w-6xl px-5 pb-12 pt-8 sm:pb-16 sm:pt-14" data-id="element-154" data-mp="x8bcg265lz9p">
        <div className="grid items-center gap-10 lg:grid-cols-[1.05fr_.95fr] lg:gap-14" data-id="element-155" data-mp="sde28rx51jv8">
          <div data-id="element-156" data-mp="nbyhl0yvhfdd">
            <p className="eyebrow text-coral-deep" data-id="element-157" data-mp="neknkw647mth">
              For acro yoga teachers, jam hosts &amp; yoga teachers adding
              partner work
            </p>
            <h1 className="mt-4 font-display text-[36px] leading-[1.08] text-night sm:text-5xl md:text-6xl" data-id="element-158" data-mp="380vy3velgpc3">
              First-timers and flyers in the same class?{' '}
              <span className="italic text-coral-deep" data-id="element-159" data-mp="3o7vllomspvze">
                It&apos;s already planned.
              </span>
            </h1>
            <p className="mt-5 max-w-xl text-base leading-relaxed text-night-soft sm:text-lg" data-id="element-160" data-mp="39a35ovdc75ko">
              Acro Yoga Class Ready gives you 60 complete sessions — partner
              yoga, L-basing, flows, inversions, jams, workshops and retreats —
              each on 3 printable pages. Every skill is written in three lanes
              that run in the same room, with where the spotter stands and the
              way down in every lane.{' '}
              <span className="font-bold text-night" data-id="element-161" data-mp="2vievwyqk8t6v">
                Open it, print it, teach every level at once.
              </span>
            </p>
            <ul className="mt-6 flex flex-wrap gap-2" data-id="element-162" data-mp="2hjym2yxeimki">
              {chips.map(chip => <li key={chip} className="rounded-full border border-sand-line bg-white/70 px-3 py-1.5 text-[11px] font-bold uppercase tracking-wide text-night-soft" data-id="element-163" data-mp="2ljz1omw8l3t5">
                  {chip}
                </li>)}
            </ul>
          </div>

          <ProductStack className="max-w-[520px]" data-id="element-164" data-mp="i9vr34bbm0lu" />
        </div>

        <div className="mt-10 flex flex-col items-center" data-id="element-165" data-mp="degcub9ei2ow">
          <div className="w-full max-w-md" data-id="element-166" data-mp="1b0nmhzkkal84">
            <CtaButton data-id="element-167" data-mp="1b0dte347zxy7">Get Acro Yoga Class Ready</CtaButton>
          </div>

          <div className="mt-5 flex max-w-md flex-col items-center gap-2.5 text-center sm:flex-row sm:text-left" data-id="element-168" data-mp="162uf537ivl69">
            <ul className="flex -space-x-1.5" aria-hidden="true" data-id="element-169" data-mp="111eqz2a1syjn">
              {lanes.map(color => <li key={color} className={`h-7 w-7 rounded-full border-2 border-sand ${color}`} data-id="element-170" data-mp="x0l3ub4fjnrt" />)}
            </ul>
            <p className="text-[13px] leading-snug text-night-muted" data-id="element-171" data-mp="3hqam6y4cdrp9">
              Built for acro teachers, jam facilitators, yoga teachers and
              retreat hosts — in the US, UK, Canada and Australia.
            </p>
          </div>

          <ul className="mt-5 flex flex-wrap justify-center gap-x-5 gap-y-2 text-xs text-night-muted" data-id="element-172" data-mp="218jv3uokcf2u">
            {micro.map(item => <li key={item} className="flex items-center gap-2" data-id="element-173" data-mp="2b0zcaps1czmo">
                <span className="h-1.5 w-1.5 rounded-full bg-coral" data-id="element-174" data-mp="2fzss4ousp2q0" />
                {item}
              </li>)}
          </ul>
        </div>
      </div>
    </section>;
}